export default "__VITE_ASSET__69a0f4c6__"